var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from 'syf-component-library/ui/spacing';
import { useMainContext } from '../../../context';
import useTriggerAnalyticsEvent from '../../../helpers/triggerAnalyticsEvent';
import useTranslation from '../../../hooks/use-translation';
import Alert from '../../common/Alert';
import HandHoldingHeartGraphic from '../../common/HandHoldingHeartGraphic';
import { StyledFlex, StyledTitle } from '../../subcomponents';
var Confirm = function () {
    var i18n = useTranslation();
    var currentRoute = useMainContext().currentRoute;
    useTriggerAnalyticsEvent({
        featureEvent: 'capPlanConfirm',
        currentRoute: currentRoute
    });
    return (_jsxs(StyledFlex, __assign({ direction: "column", alignItems: "center" }, { children: [_jsx(Alert, { title: i18n('common.confirmEnrollBannerText') }), _jsx(Stack, { size: "xlarge" }), _jsxs(StyledFlex, __assign({ direction: "column", alignItems: "center" }, { children: [_jsx(HandHoldingHeartGraphic, {}), _jsx(Stack, { size: "xlarge" }), _jsx(StyledTitle, __assign({ weight: "bold", size: "medium", align: "center" }, { children: i18n('plan.confirmHeading') }))] }))] })));
};
export default Confirm;
//# sourceMappingURL=index.js.map